/* Maisto Caffè — Hinweis bei Auswahl eines gemahlenen Mahlgrads.
   Angelegt 29.07.2026. Hintergrund: auf allen Tüten steht "Ganze Bohnen"
   (es gibt keine eigene Verpackung für gemahlen) — Kunden bestellten
   versehentlich gemahlen und reklamierten nach Erhalt.

   Erkennung läuft über den Wort-Bestandteil "gemahlen" im Variantenwert
   ("Espresso // fein gemahlen" usw.), gilt daher für jede Sorte automatisch,
   auch für neu angelegte. Keine Varianten-IDs zu pflegen.

   Entfernen: diese Datei löschen + die eine Script-Zeile in layout/theme.liquid. */

(function () {
  'use strict';

  var GEMAHLEN = /gemahlen/i;
  var GANZE = /^\s*ganze\s+bohne/i;
  var schonGezeigt = false;   // einmal pro Seitenaufruf, nicht bei jedem Klick
  var dialog = null;
  var vorherFokussiert = null;

  function stil() {
    if (document.getElementById('maisto-mahlgrad-stil')) return;
    var s = document.createElement('style');
    s.id = 'maisto-mahlgrad-stil';
    s.textContent = [
      '.maisto-mh-overlay{position:fixed;inset:0;z-index:2147483000;display:flex;',
      'align-items:center;justify-content:center;padding:20px;',
      'background:rgba(20,17,14,.62);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);}',
      '.maisto-mh-box{background:#fff;color:#191512;max-width:430px;width:100%;',
      'border-radius:6px;padding:28px 26px 22px;box-shadow:0 18px 50px rgba(0,0,0,.3);',
      'font-family:inherit;text-align:left;animation:maisto-mh-auf .18s ease-out;}',
      '@keyframes maisto-mh-auf{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
      '@media (prefers-reduced-motion:reduce){.maisto-mh-box{animation:none}}',
      '.maisto-mh-kopf{display:flex;align-items:center;gap:10px;margin-bottom:14px;}',
      '.maisto-mh-icon{flex:0 0 auto;width:30px;height:30px;border-radius:50%;',
      'background:#F4E2C4;color:#8A5A12;display:flex;align-items:center;justify-content:center;',
      'font-size:17px;font-weight:700;line-height:1;}',
      '.maisto-mh-titel{font-size:1.12rem;font-weight:700;margin:0;line-height:1.25;}',
      '.maisto-mh-text{font-size:.95rem;line-height:1.55;margin:0 0 6px;}',
      '.maisto-mh-wahl{display:block;margin:12px 0 18px;padding:9px 12px;background:#F5F3EF;',
      'border-left:3px solid #8A5A12;font-size:.9rem;font-weight:600;word-break:break-word;}',
      '.maisto-mh-knoepfe{display:flex;gap:10px;flex-wrap:wrap;}',
      '.maisto-mh-knoepfe button{flex:1 1 160px;padding:12px 14px;font-size:.93rem;',
      'font-family:inherit;font-weight:600;border-radius:4px;cursor:pointer;line-height:1.3;}',
      '.maisto-mh-ja{background:#191512;color:#fff;border:1px solid #191512;}',
      '.maisto-mh-ja:hover{background:#000;}',
      '.maisto-mh-zurueck{background:#fff;color:#191512;border:1px solid #C9C2B7;}',
      '.maisto-mh-zurueck:hover{border-color:#191512;}',
      '.maisto-mh-knoepfe button:focus-visible{outline:2px solid #8A5A12;outline-offset:2px;}'
    ].join('');
    document.head.appendChild(s);
  }

  /* Das "Ganze Bohne"-Radio in derselben Auswahlgruppe finden */
  function ganzeBohneRadio(radio) {
    var gruppe = radio.closest('fieldset') || radio.parentNode;
    if (!gruppe) return null;
    var alle = gruppe.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < alle.length; i++) {
      if (GANZE.test(alle[i].value || '')) return alle[i];
    }
    return null;
  }

  function schliessen() {
    if (!dialog) return;
    dialog.remove();
    dialog = null;
    document.removeEventListener('keydown', beiTaste, true);
    if (vorherFokussiert && vorherFokussiert.focus) {
      try { vorherFokussiert.focus(); } catch (e) {}
    }
  }

  function beiTaste(e) {
    if (!dialog) return;
    if (e.key === 'Escape') { e.preventDefault(); schliessen(); return; }
    if (e.key !== 'Tab') return;
    var f = dialog.querySelectorAll('button');
    if (!f.length) return;
    var erst = f[0], letzt = f[f.length - 1];
    if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
    else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
  }

  function zeigen(wert, radio) {
    stil();
    vorherFokussiert = document.activeElement;

    var zurueck = ganzeBohneRadio(radio);

    dialog = document.createElement('div');
    dialog.className = 'maisto-mh-overlay';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'maisto-mh-titel');

    var box = document.createElement('div');
    box.className = 'maisto-mh-box';

    var kopf = document.createElement('div');
    kopf.className = 'maisto-mh-kopf';
    var ic = document.createElement('span');
    ic.className = 'maisto-mh-icon';
    ic.setAttribute('aria-hidden', 'true');
    ic.textContent = '!';
    var ti = document.createElement('h2');
    ti.className = 'maisto-mh-titel';
    ti.id = 'maisto-mh-titel';
    ti.textContent = 'Achtung: gemahlener Kaffee';
    kopf.appendChild(ic);
    kopf.appendChild(ti);

    var tx = document.createElement('p');
    tx.className = 'maisto-mh-text';
    tx.textContent = 'Wir mahlen den Kaffee frisch – nur für dich. Bitte stell sicher, dass du ihn wirklich gemahlen möchtest und keine ganzen Bohnen.';

    var wa = document.createElement('strong');
    wa.className = 'maisto-mh-wahl';
    wa.textContent = 'Deine Auswahl: ' + wert;

    var kn = document.createElement('div');
    kn.className = 'maisto-mh-knoepfe';

    if (zurueck) {
      var bz = document.createElement('button');
      bz.type = 'button';
      bz.className = 'maisto-mh-zurueck';
      bz.textContent = 'Doch ganze Bohnen';
      bz.addEventListener('click', function () {
        schliessen();
        zurueck.checked = true;
        zurueck.dispatchEvent(new Event('change', { bubbles: true }));
        if (typeof zurueck.click === 'function' && !zurueck.checked) zurueck.click();
      });
      kn.appendChild(bz);
    }

    var bj = document.createElement('button');
    bj.type = 'button';
    bj.className = 'maisto-mh-ja';
    bj.textContent = 'Ja, gemahlen';
    bj.addEventListener('click', schliessen);
    kn.appendChild(bj);

    box.appendChild(kopf);
    box.appendChild(tx);
    box.appendChild(wa);
    box.appendChild(kn);
    dialog.appendChild(box);

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) schliessen();
    });

    document.body.appendChild(dialog);
    document.addEventListener('keydown', beiTaste, true);
    bj.focus();
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.type !== 'radio' || !el.checked) return;
    if (!el.closest('variant-selects, variant-radios, .product-form__input')) return;

    var wert = el.value || '';
    if (!GEMAHLEN.test(wert)) return;
    if (schonGezeigt) return;

    schonGezeigt = true;
    zeigen(wert.trim(), el);
  }, true);
})();
